import { render, staticRenderFns } from "./drag-drop-images.vue?vue&type=template&id=3d8b71ea&"
import script from "./drag-drop-images.vue?vue&type=script&lang=js&"
export * from "./drag-drop-images.vue?vue&type=script&lang=js&"
import style0 from "./drag-drop-images.vue?vue&type=style&index=0&id=3d8b71ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports